export const MEMBER_KEY = 'member';
export const MEMBERS_KEY = 'members';
export const UPDATE_MEMBER_KEY = 'updateMember';
export const DELETE_MEMBER_KEY = 'deleteMember';
export const getMemberKey = (args) => [MEMBER_KEY, args];
export const getMembersKey = (args, fields) => (args || fields ? [MEMBERS_KEY, args, fields] : [MEMBERS_KEY]);
export const getUpdateMemberKey = () => UPDATE_MEMBER_KEY;
export const getDeleteMemberKey = () => DELETE_MEMBER_KEY;
//# sourceMappingURL=member.key.js.map